import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
export class ConditionRegistryLogic extends ConditionRegistryCategory {
    label = 'Logik';
    constructor(parent) {
        super(parent);
        super.init();
    }
    never = () => new ConditionRegistryItem({ eval: () => false });
    always = () => new ConditionRegistryItem({ eval: () => true });
    once = () => new ConditionRegistryItem({
        eval: ({ evaluator, rightChildEvaluator }) => {
            if (evaluator.entityTemp.flexMapPlain.has('wasOnceTrue'))
                return true;
            if (!!rightChildEvaluator && rightChildEvaluator.isConditionTrue) {
                evaluator.entityTemp.flexMapPlain.set('wasOnceTrue', true);
                return true;
            }
            return false;
        }
    });
    and = () => new ConditionRegistryItem({
        eval: ({ leftChildEvaluator, rightChildEvaluator }) => !!leftChildEvaluator &&
            !!rightChildEvaluator &&
            leftChildEvaluator.isConditionTrue &&
            rightChildEvaluator.isConditionTrue
    });
    or = () => new ConditionRegistryItem({
        eval: ({ leftChildEvaluator, rightChildEvaluator }) => !!leftChildEvaluator &&
            !!rightChildEvaluator &&
            (leftChildEvaluator.isConditionTrue || rightChildEvaluator.isConditionTrue)
    });
    not = () => new ConditionRegistryItem({
        eval: ({ rightChildEvaluator }) => !!rightChildEvaluator && !rightChildEvaluator.isConditionTrue
    });
    compare = () => new ConditionRegistryItem({
        eval: ({ evaluator }) => {
            const left = evaluator.valueOf.leftValue;
            const right = evaluator.valueOf.rightValue;
            const op = '=='; // TODO: get from aspect setting!!
            if (op === '==') {
                return left === right;
            }
            if (op === '!=') {
                return left !== right;
            }
            if (op === '>') {
                return left > right;
            }
            if (op === '<') {
                return left < right;
            }
            if (op === '>=') {
                return left >= right;
            }
            if (op === '<=') {
                return left <= right;
            }
            if (op === '===') {
                return left === right;
            }
            if (op === '!==') {
                return left !== right;
            }
            return false;
        },
        /*    params: { core: ['comparator', 'leftValue', 'rightValue'] } */
    });
}
